import { FilterBase } from '@myapp/modules/forms/models';

export class UserFilter extends FilterBase {

  GetFilter(inputValue: string) {
    return {
      filter: {
        logic: "or",
        filters: [
          {
            field: "firstName",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "lastName",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "companyName",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "alias",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "email",
            operator: "contains",
            value: inputValue,
          },
        ],
      },
    };
  }

}
